'use client'

import React from "react";
import classNames from "classnames";
import MapSide from "./MapSide";
import { TableMapProvider, useTableMapState } from "./TableMapState";
import InventoryTable from "./InventoryTable";
import { GlobalProvider } from "@/migrated-widgets/table-map/contexts/GlobalState";
import { TableMapFilters } from "./TableMapFilters";
import useExportTableMap from "./hooks/useExportTableMap";

// Content component - renders the filters (via portal), map and table
const TableMapContent: React.FC = () => {
    useExportTableMap();
    const { onlyMap, collapsed } = useTableMapState();

    return (
        <>
            {/* Filters render via portal to widget header */}
            <TableMapFilters />
            <div
                className={classNames("grid w-full h-[529px] items-stretch transition-all duration-500 delay-300 ease-in-out", { "!h-0": collapsed })}
                style={{ gridTemplateColumns: "316px auto" }}
            >
                {!onlyMap && <InventoryTable />}
                <div className={classNames("relative", { "col-span-2": onlyMap })}>
                    <MapSide />
                </div>
            </div>
        </>
    )
}

const TableMapProviderWrapper: React.FC<{}> = () => {
    return (
        <GlobalProvider>
            <TableMapProvider>
                <TableMapContent />
            </TableMapProvider>
        </GlobalProvider>
    )
}


export default React.memo(TableMapProviderWrapper);
export { TableMapContent, TableMapProviderWrapper };